'use strict';

import Backbone from 'backbone';
import { loadForm, navigate, routerLoaded } from "Actions/ApplicationActions";
import ApplicationStore from "Stores/ApplicationStore";
import { user } from "Models/UserModel";
import { topBarSetTitle } from "Actions/TopBarActions";
import { Fields, System } from "Constants/objects";
import { loadSubSystem } from "D5Utils/common_requests";
import { deleteAllCookies, setReturnUrl } from "D5Utils/functions";
ApplicationStore.register();
var History = Backbone.History.extend({
  // for redirecting to page404 if no such page define in router
  loadUrl: function loadUrl() {
    var match = Backbone.History.prototype.loadUrl.apply(this, arguments);
    if (!match) router.navigateTo(System.page404);
    return match;
  }
});
Backbone.history = new History();
var Router = Backbone.Router.extend({
  initialize: function initialize(options) {
    this.route('(/)', function () {
      this.emitNavigate('').then(function () {
        loadForm(); //пока что так

        topBarSetTitle();
      });
    });
    this.route('login(/)', function () {
      this.emitNavigate(System.login);
    });
    this.route('subsystem/:id(/)', function (id) {
      var _this = this;

      loadSubSystem(id).then(function (subsystems) {
        if (!subsystems.length) {
          router.navigateTo(System.page404);
          return;
        }

        var sortedCollection = _.sortBy(subsystems, Fields.Order);

        var _sortedCollection$ = sortedCollection[0],
            subSysFormID = _sortedCollection$[Fields.FormID],
            subSysType = _sortedCollection$[Fields.FormID_Type];

        _this.emitNavigate("subsystem/".concat(id)).then(function () {
          if (subSysFormID == null) loadForm();else loadForm({
            viewMode: System.VIEW_MODE.FULL_SCREEN,
            formID: subSysFormID,
            type: subSysType
          });
        });
      });
    });
    this.route(new RegExp("".concat(SUBSYSTEM_ROUTE, "\\/").concat(EDIT_FORM_ROUTE, "$")), function (parentRout, operation, editFormID, keys) {
      if (!keys && operation === System.FORM_EDIT_CREATE_MODE.EDIT) {
        this.navigateTo(SUBSYSTEM_STR + parentRout);
        return;
      }

      var keyID = operation === System.FORM_EDIT_CREATE_MODE.MULTI_EDIT ? keys.split('=')[1].split('&') : (keys || '').split('=')[1];
      var url = createEditUrl({
        parentRoute: parentRout,
        mode: operation,
        formID: editFormID,
        id: keyID
      });
      this.emitNavigate(url).then(function () {
        loadForm({
          formID: editFormID,
          type: System.FORM_TYPE.EDIT,
          viewMode: System.VIEW_MODE.FULL_SCREEN,
          urlObj: {
            parentRoute: parentRout,
            mode: operation,
            formID: editFormID,
            id: keyID
          }
        });
      });
    });
  },
  navigateTo: function navigateTo(route) {
    var _this2 = this;

    var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return new Promise(function (resolve, reject) {
      if (_this2.navigate(route, {
        trigger: trigger
      })) resolve();else reject();
    });
  },
  emitNavigate: function emitNavigate(route) {
    if (route !== System.login && (!user.getUserID() || !user.getName())) {
      return this.navigateTo(System.login);
    } else {
      setReturnUrl();
      setTimeout(function () {
        navigate(route);
      });
      return Promise.resolve();
    }
  },
  createUrl: function createUrl(method, object) {
    var methods = {
      "create": "Ins",
      "read": 'List',
      "update": "Mod",
      "delete": "Del"
    };
    return [this.getAPIUrl(), object, methods[method]].join('/');
  },
  getAPIUrl: function getAPIUrl() {
    return '/wapi';
  }
});
export var createEditUrl = function createEditUrl() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$parentRoute = _ref.parentRoute,
      parentRoute = _ref$parentRoute === void 0 ? '/' : _ref$parentRoute,
      mode = _ref.mode,
      formID = _ref.formID,
      id = _ref.id;

  var editPart = '';

  if (mode.includes(System.FORM_EDIT_CREATE_MODE.EDIT)) {
    editPart = '?id=' + id;
  }

  if (parentRoute[parentRoute.length - 1] !== '/') parentRoute += '/';
  return "".concat(parentRoute).concat(mode, "/").concat(formID, "/").concat(editPart);
};
export var EDIT_FORM_ROUTE = '(edit|add|multi_edit)\\/(\\d+)\/?(\\?id=.+)?';
export var SUBSYSTEM_ROUTE = '(subsystem\\/\\d+)';
export var SUBSYSTEM_STR = '#subsystem/';
var router = new Router();
user.checkLogin(function () {
  Backbone.history.start();
  router = new Router();
  routerLoaded();
}, function () {
  Backbone.history.start();
  deleteAllCookies();
  setReturnUrl();
  localStorage.removeItem(System.current_user);
  router.navigateTo(System.login).then(function () {
    routerLoaded();
  });
});
export default router;